// Define Team member positions
const POSSIBLE_TEAM_MEMBER_POSITIONS = ['CEO', 'CTO', 'COO', 'CFO', 'CMO']

export default POSSIBLE_TEAM_MEMBER_POSITIONS
